import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BankAppProvider } from "./BankContext/BankAppContext";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";


// import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <BankAppProvider>
          <App />
        </BankAppProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals